<script>
  import {media} from 'svelte-match-media'
</script>
<div class="chart">
  <h4 class="title">Optimal Frequency</h4>
  {#if $media.mobile}
    <svg width="348" height="218" viewBox="0 0 348 218" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="gray-line">
        <line x1="66" y1="20.5" x2="347" y2="20.5"/>
        <line x1="66" y1="65.5" x2="347" y2="65.5"/>
        <line x1="66" y1="110.5" x2="347" y2="110.5"/>
        <line x1="66" y1="155.5" x2="347" y2="155.5"/>
      </g>
      <g class="white bold">
        <text><tspan x="157" y="203.304">Frequency</tspan></text>
        <text transform="translate(0 141) rotate(-90)"><tspan x="0" y="14.304">Conversion Rate</tspan></text>
      </g>
      <g class="white small bold">
        <text><tspan x="28" y="24.632">.30%</tspan></text>
        <text><tspan x="28" y="70.632">.20%</tspan></text>
        <text><tspan x="32" y="115.632">.10%</tspan></text>
        <text><tspan x="28" y="159.632">.00%</tspan></text>
        <text><tspan x="65" y="174.632">0</tspan></text>
        <text><tspan x="125" y="174.632">2</tspan></text>
        <text><tspan x="185" y="174.632">4</tspan></text>
        <text><tspan x="245" y="174.632">6</tspan></text>
        <text><tspan x="305" y="174.632">8</tspan></text>
      </g>
      <path class="chart-line" d="M67 125C71.4772 119.707 82.0849 107.688 88.6974 101.951C96.9631 94.7805 112.978 75.3171 118.661 69.6829C124.343 64.0488 137.258 51.7561 157.923 45.6098C162.916 44.0732 174.764 41 182.203 41C191.502 41 203.9 45.6098 213.199 45.6098C222.498 45.6098 230.247 49.7073 234.38 49.7073C238.513 49.7073 240.579 49.7073 247.295 49.7073C252.668 49.7073 316.004 69.8537 347 79.9268"/>
      <g class="white-line">
        <path d="M176.695 27.9168L176.695 0.305664" />
        <path d="M190.695 14.6946L176.695 28.6946L162.695 14.6946" />
      </g>
    </svg>
  {:else}
    <svg width="601" height="274" viewBox="0 0 601 274" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="gray-line">
        <line x1="125.935" y1="19.7246" x2="600" y2="19.7246"/>
        <line x1="125.935" y1="79.9312" x2="600" y2="79.9312"/>
        <line x1="125.935" y1="141.083" x2="600" y2="141.083"/>
        <line x1="126" y1="208.836" x2="600.065" y2="208.836"/>
      </g>
      <g class="white bold larger">
        <text><tspan x="286" y="268.207">Frequency</tspan></text>
        <text transform="translate(0 179.336) rotate(-90)"><tspan x="0" y="17.048">Conversion Rate</tspan></text>
      </g>
      <g class="white bold">
        <text><tspan x="61.8262" y="20.9437">.30%</tspan></text>
        <text><tspan x="61.8262" y="81.6508">.20%</tspan></text>
        <text><tspan x="66.8877" y="142.801">.10%</tspan></text>
        <text><tspan x="60.1396" y="209.113">.00%</tspan></text>
        <text><tspan x="124.248" y="230.755">0</tspan></text>
        <text><tspan x="225.473" y="230.755">2</tspan></text>
        <text><tspan x="326.695" y="230.755">4</tspan></text>
        <text><tspan x="427.92" y="230.755">6</tspan></text>
        <text><tspan x="529.144" y="230.755">8</tspan></text>
      </g>
      <path class="chart-line" d="M127.622 164.611C135.175 156.974 153.071 139.633 164.227 131.356C178.172 121.011 205.19 92.9296 214.777 84.8008C224.364 76.672 246.152 58.9365 281.014 50.0688C289.439 47.8518 309.427 43.418 321.977 43.418C337.665 43.418 358.582 50.0688 374.27 50.0688C389.957 50.0688 403.031 55.9806 410.003 55.9806C416.975 55.9806 420.462 55.9806 431.792 55.9806C440.856 55.9806 547.707 85.0471 600 99.5804"/>
      <path class="white-line" d="M322 27.6111L322 0M336 14.3889L322 28.3889L308 14.3889"/>
    </svg>
  {/if}
</div>
<style>
  .title {
    margin: 0 0 0.5rem;
    font-weight: bold;
  }
  svg {
    margin: 0;
    width: 100%;
    max-width: 348px;
  }
  svg text {
    font-family: inherit;
    white-space: pre;
    font-size: 14px;
  }
  .bold text {
    font-weight: bold
  }
  .white {
    fill: white
  }
  .small text {
    font-size: 12px
  }
  .larger text {
    font-size: 18px
  }
  .chart-line {
    stroke: var(--verizon-red);
    stroke-width: 4;
  }
  .gray-line {
    stroke: var(--gray-line)
  }
  .white-line {
    stroke: white;
    stroke-width: 2;
  }
  @media(min-width: 768px) {
    svg {
      max-width: none;
    }
  }
</style>